import URLConfig from '@Config/urls/url.config';
import * as GimacModule from '@Modules/interfaceManagement/gimac/pages';
import { Route } from "react-router-dom";

const URL = URLConfig.INTERFACE_MANAGEMENT.GIMAC;

const GimacRoutes = [
  // Settings Menu Routes
  <Route
    path={URL.SETTINGS}
    element={<GimacModule.SettingsPage />}
  />,

  // Transaction Menu Routes
  <Route
    path={URL.TRANSACTION_MENU.CONSULTING_VALID_TRANSACTIONS}
    element={<GimacModule.ConsultingValidTransactionPage />}
  />,
  <Route
    path={URL.TRANSACTION_MENU.CONSULTING_GIMAC_TRANSACTIONS}
    element={<GimacModule.ConsultingGimacTransactionPage />}
  />,
  <Route
    path={URL.TRANSACTION_MENU.CONSULTING_VALID_SETTLEMENTS}
    element={<GimacModule.ConsultingValidSettlementsPage />}
  />,

  // Acquirer Menu Routes
  <Route
    path={URL.ACQUIRER_MENU.TRANSACTION_ACQUISITION_NOTICE}
    element={<GimacModule.TransactionAcquisitionNoticePage />}
  />,
  <Route
    path={URL.ACQUIRER_MENU.CAPTURE_OF_REPRESENTATION}
    element={<GimacModule.CaptureOfRepresentationPage />}
  />,
  <Route
    path={URL.ACQUIRER_MENU.CAPTURE_OF_CANCELLATION}
    element={<GimacModule.CaptureOfCancellationPage />}
  />,
  <Route
    path={URL.ACQUIRER_MENU.CONSULTING_CANCELLATIONS}
    element={<GimacModule.ConsultingCancellationsPage />}
  />,

  // Emitter Menu Routes
  <Route
    path={URL.EMITTER_MENU.TRANSACTION_NOTICE}
    element={<GimacModule.TransactionNoticePage />}
  />,
  <Route
    path={URL.EMITTER_MENU.ENTER_A_CHARGEBACK}
    element={<GimacModule.EnterChargeBackPage />}
  />,
  <Route
    path={URL.EMITTER_MENU.CHARGEBACK_CANCELLATION}
    element={<GimacModule.ChargeBackCancellationPage />}
  />,
  <Route
    path={URL.EMITTER_MENU.CONSULTING_OF_CHARGEBACK}
    element={<GimacModule.ConsultingOfChargeBackPage />}
  />,
  <Route
    path={URL.EMITTER_MENU.CONSULTING_OF_CHARGEBACK_CANCELLATIONS}
    element={<GimacModule.ConsultingOfChargeBackCancellationsPage />}
  />,

  // Batches Menu Routes
  <Route
    path={URL.BATCHES_MENU.BATCHES_MONITORING}
    element={<GimacModule.GimacBatchesMonitoringPage />}
  />,
  <Route
    path={URL.BATCHES_MENU.BATCHES_ERRORS}
    element={<GimacModule.GimacBatchErrorsPage />}
  />,
  <Route
    path={URL.BATCHES_MENU.BATCHES_TRACES}
    element={<GimacModule.GimacBatchesTracksPage />}
  />,

];

export default GimacRoutes;
